"use client";

import { c as _c } from "react/compiler-runtime";
import { KeyRound, LogIn } from "lucide-react";
import { useLoginRedirect } from "@/features/auth/useLoginRedirect";
import { Dialog } from "./ui";
import "./overlays.css";

/**
 * "SIGN IN FIRST", in v2 — opened by the app's auth store whenever an action
 * needs an account (like, save, comment, bid …). The deleted legacy
 * LoginRedirectModal's flow: to sign-in with this page (and its query) as
 * the way back, through `useLoginRedirect`.
 */
export default function SignInPrompt(t0) {
  const $ = _c(23);
  const {
    open,
    onClose,
    lang
  } = t0;
  const isFa = lang === "fa";
  const goToLogin = useLoginRedirect(lang);
  const t1 = isFa ? "\u0646\u06CC\u0627\u0632 \u0628\u0647 \u0648\u0631\u0648\u062F \u062F\u0627\u0631\u06CC\u062F" : "Sign in required";
  const t2 = isFa ? "\u0628\u0633\u062A\u0646" : "Close";
  const t3 = isFa ? "\u062D\u0627\u0644\u0627 \u0646\u0647" : "Not now";
  let t4;
  if ($[0] !== onClose || $[1] !== t3) {
    t4 = <button type="button" className="v2-btn v2-btn--ghost v2-focus" onClick={onClose}>{t3}</button>;
    $[0] = onClose;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== goToLogin || $[4] !== onClose) {
    t5 = () => {
      goToLogin();
      onClose();
    };
    $[3] = goToLogin;
    $[4] = onClose;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LogIn aria-hidden={true} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isFa ? "\u0648\u0631\u0648\u062F \u0628\u0647 \u062D\u0633\u0627\u0628" : "Sign in";
  let t8;
  if ($[7] !== t5 || $[8] !== t7) {
    t8 = <button type="button" className="v2-btn v2-focus" onClick={t5}>{t6}{t7}</button>;
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <div className="v2-signin-foot">{t4}{t8}</div>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="v2-signin-mark" aria-hidden={true}><KeyRound /></span>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = isFa ? "\u0628\u0631\u0627\u06CC \u067E\u0633\u0646\u062F\u06CC\u062F\u0646\u060C \u0630\u062E\u06CC\u0631\u0647 \u06A9\u0631\u062F\u0646\u060C \u0646\u0648\u0634\u062A\u0646 \u062F\u06CC\u062F\u06AF\u0627\u0647 \u06CC\u0627 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062F\u0627\u062F\u0646\u060C \u0627\u0648\u0644 \u0648\u0627\u0631\u062F \u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC\u200C\u062A\u0627\u0646 \u0634\u0648\u06CC\u062F. \u0628\u0639\u062F \u0627\u0632 \u0648\u0631\u0648\u062F \u0628\u0647 \u0647\u0645\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0631\u0645\u06CC\u200C\u06AF\u0631\u062F\u06CC\u062F." : "To like, save, comment or bid, sign in to your account first. You'll come straight back to this page.";
  let t12;
  if ($[14] !== t11) {
    t12 = <div className="v2-signin-body">{t10}<p>{t11}</p></div>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== onClose || $[17] !== open || $[18] !== t1 || $[19] !== t12 || $[20] !== t2 || $[21] !== t9) {
    t13 = <div className="v2 v2-pop-portal"><Dialog open={open} onClose={onClose} title={t1} closeLabel={t2} className="v2-signin" footer={t9}>{t12}</Dialog></div>;
    $[16] = onClose;
    $[17] = open;
    $[18] = t1;
    $[19] = t12;
    $[20] = t2;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}